import React from 'react';
import { AnyAction } from 'redux';
import { AppState } from '../store'
import { Switch, List, ListItem, ListItemText, ListItemSecondaryAction, Slider, makeStyles, Card, CardContent } from '@material-ui/core';
import { toggleFullScreen, togglePlayVideosOnce, toggleAudioOnlyOnce, setClipLength } from '../store/system/actions';

const useStyles = makeStyles({
    root: {
      width: 150,
    },
  });

export default (state: AppState, dispatch: React.Dispatch<AnyAction>) => {

    const classes = useStyles();

    return {
        name: "SessionConfig",
        label: "Configure the session",
        content: (

            <Card>
                <CardContent>

                <List>
                    <ListItem>
                    <ListItemText primary="Video clip length (seconds)" />
                    <ListItemSecondaryAction>
                        <div className={classes.root}>
                        <Slider
                            value={state.system.clipLength}
                            onChange={ (e:any, newValue:number | number[]) => dispatch( setClipLength(newValue as number[]) )}
                            aria-labelledby="discrete-slider"
                            valueLabelDisplay="on"
                            step={10}
                            min={10}
                            max={300}
                        />
                        </div>
                    </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                    <ListItemText primary="Play videos full screen" />
                    <ListItemSecondaryAction>
                        <Switch checked={state.system.fullScreen} onChange={() => dispatch(toggleFullScreen()) } />
                    </ListItemSecondaryAction>
                    </ListItem> 
                    
                    <ListItem>
                    <ListItemText primary="Play videos once" />
                    <ListItemSecondaryAction>
                        <Switch checked={state.system.playVideoOnce} onChange={() => dispatch(togglePlayVideosOnce()) } />
                    </ListItemSecondaryAction>
                    </ListItem>
                    
                    {/* <ListItem>
                    <ListItemText primary="Include random blackouts" />
                    <ListItemSecondaryAction>
                        <Switch checked={state.system.randomBlackouts} onChange={() => dispatch(toggleRandomBlackoutsOnce()) } />
                    </ListItemSecondaryAction>
                    </ListItem> */}
                    
                    <ListItem>
                    <ListItemText primary="Audio only" />
                    <ListItemSecondaryAction>
                        <Switch checked={state.system.audioOnly} onChange={() => dispatch(toggleAudioOnlyOnce()) } />
                    </ListItemSecondaryAction>
                    </ListItem>       

                </List>

            </CardContent>
            </Card>

        )
    }
}